module.exports = __webpack_public_path__ + "img/is.ae44c07e.svg";